import type { ColumnsType } from "antd/es/table";
import type { LookupTableOption } from "../../Components/DataEntry/Select/LookupTableSelect";
import { getLookupTableText } from "./helpers";

export const buildCustomerLookupOption = (customer: any) => ({
  ...customer,
  label: customer?.name,
  value: customer?._id,
  raw: customer,
});

const customerTableColumns: ColumnsType<LookupTableOption> = [
  {
    title: "Tên",
    dataIndex: "name",
    width: 180,
    render: (_value, record) => getLookupTableText(record, "name"),
  },
  {
    title: "Mã khách hàng",
    dataIndex: "code",
    width: 150,
    render: (_value, record) => getLookupTableText(record, "code"),
  },
  {
    title: "Tên đầy đủ",
    dataIndex: "fullName",
    width: 240,
    render: (_value, record) => getLookupTableText(record, "fullName"),
  },
  {
    title: "SĐT",
    dataIndex: "phoneNumber",
    width: 140,
    render: (_value, record) => getLookupTableText(record, "phoneNumber"),
  },
  {
    title: "Mã số thuế",
    dataIndex: ["businessLicense", "text"],
    width: 160,
    render: (_value, record) =>
      getLookupTableText(record, ["businessLicense", "text"]),
  },
  {
    title: "Tỉnh/TP",
    dataIndex: ["address", "province"],
    width: 160,
    render: (_value, record) =>
      getLookupTableText(record, ["address", "province"]),
  },
  {
    title: "Địa chỉ",
    dataIndex: ["address", "text"],
    width: 260,
    render: (_value, record) => getLookupTableText(record, ["address", "text"]),
  },
];

export const customerLookupTable = {
  popupWidth: 1180,
  searchPlaceholder: "Tìm theo tên khách hàng",
  tableColumns: customerTableColumns,
};
